const json = [
    {
        path: 'administration/menus',
        name: 'Menus',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'menu.list',
            permissionPrefix: 'menu',
            mainTitle: 'Menus',
            auth: 'admin',
            connectionName: 'Menu',
            selectRows: false,
            formRoute: 'MenuPreviewForm',
            idField: 'menuId',
            columns: [
                {
                    text: 'ID',
                    value: 'menuId'
                },
                {
                    text: 'Title',
                    value: 'menuName'
                },
                {
                    text: 'Description',
                    value: 'menuDescription'
                },
                {
                    text: 'Active',
                    value: 'menuEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'menuEnabled',
                        customButtons: [
                            {
                                icon: 'mdi-menu',
                                color: 'info',
                                tooltip: 'Edit Items',
                                actionType: 'routeMenu',
                                actionParams: 'menuId',
                                action: 'MenuItemForm'
                            }
                        ]
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'menuName'
                },
                {
                    text: 'Description',
                    type: 'text',
                    value: 'menuDescription'
                }
            ]
        }
    },
    {
        path: 'administration/permissions',
        name: 'Permissions',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'permission.list',
            permissionPrefix: 'permission',
            mainTitle: 'Permissions',
            auth: 'admin',
            connectionName: 'Permissions',
            selectRows: false,
            formRoute: 'PermissionsForm',
            idField: 'permissionId',
            columns: [
                {
                    text: 'ID',
                    value: 'permissionId'
                },
                {
                    text: 'Name',
                    value: 'permissionName'
                },
                {
                    text: 'Active',
                    value: 'permissionEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    customField: {
                        fieldEnabled: 'permissionEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'permissionName'
                }
            ]
        }
    },
    {
        path: 'administration/roles',
        name: 'Roles',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'role.list',
            permissionPrefix: 'role',
            mainTitle: 'Roles',
            connectionName: 'Roles',
            auth: 'admin',
            selectRows: false,
            formRoute: 'RolesForm',
            idField: 'roleId',
            columns: [
                {
                    text: 'ID',
                    value: 'roleId'
                },
                {
                    text: 'Name',
                    value: 'roleName'
                },
                {
                    text: 'Active',
                    value: 'roleEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'roleEnabled',
                        hideAll: false,
                        customButtons: [
                            {
                                icon: 'mdi-lock',
                                color: 'info',
                                tooltip: 'Edit Permissions',
                                actionType: 'route',
                                actionParams: 'roleId',
                                action: 'RolesPermissionsForm'
                            }
                        ]
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'roleName'
                }
            ]
        }
    },
    {
        path: 'administration/users',
        name: 'Users',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'user.list',
            permissionPrefix: 'user',
            mainTitle: 'Users',
            auth: 'admin',
            connectionName: 'Users',
            selectRows: false,
            formRoute: 'UsersForm',
            idField: 'userId',
            columns: [
                {
                    text: 'ID',
                    value: 'userId'
                },
                {
                    text: 'Username',
                    value: 'username'
                },
                {
                    text: 'Carrrier',
                    value: 'carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName',
                    sortable: false
                },
                {
                    text: 'Last Login',
                    value: 'lastLogin',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Active',
                    value: 'userEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'date_modified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'userEnabled',
                        hideAll: false,
                        customButtons: [
                            {
                                icon: 'mdi-book',
                                color: 'info',
                                tooltip: 'Edit Roles',
                                actionType: 'route',
                                actionParams: 'userId',
                                action: 'UserRolesForm'
                            },
                            {
                                icon: 'mdi-book-open-variant',
                                color: 'info lighten-1',
                                tooltip: 'Edit Permissions',
                                actionType: 'route',
                                actionParams: 'userId',
                                action: 'UserPermissionsForm'
                            },
                            {
                                icon: 'mdi-shield-key',
                                color: '#cc0000',
                                tooltip: 'Change Password',
                                actionType: 'userPassword'
                            }
                        ]
                    }
                }
            ],
            filters: [
                {
                    text: 'Username',
                    type: 'text',
                    value: 'username'
                },
                {
                    text: 'Email',
                    type: 'text',
                    value: 'email'
                },
                {
                    text: 'Phone',
                    type: 'text',
                    value: 'phone'
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                }
            ]
        }
    },
    {
        path: 'settings/countries',
        name: 'Countries',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'country.list',
            permissionPrefix: 'country',
            mainTitle: 'Countries',
            auth: 'admin',
            connectionName: 'Countries',
            selectRows: false,
            formRoute: 'CountriesForm',
            idField: 'countryId',
            columns: [
                {
                    text: 'ID',
                    value: 'countryId'
                },
                {
                    text: 'Country',
                    value: 'countryName'
                },
                {
                    text: 'Shortname',
                    value: 'countryShort'
                },
                {
                    text: 'Currency',
                    value: 'countryCurrency'
                },
                {
                    text: 'Exchange',
                    value: 'countryCurrencyExchange'
                },
                {
                    text: 'Country Code',
                    value: 'countryCode'
                },
                {
                    text: 'Active',
                    value: 'countryEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'countryEnabled'
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'countryName'
                },
                {
                    text: 'Country Short',
                    type: 'text',
                    value: 'countryShort'
                },
                {
                    text: 'Country',
                    type: 'text',
                    value: 'countryName'
                },
                {
                    text: 'Currency',
                    type: 'text',
                    value: 'countryCurrency'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'countryEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/carriers',
        name: 'Carriers',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'carrier.list',
            permissionPrefix: 'carrier',
            mainTitle: 'Carriers',
            auth: 'admin',
            connectionName: 'Carriers',
            selectRows: false,
            formRoute: 'CarriersForm',
            idField: 'carrierId',
            columns: [
                {
                    text: 'ID',
                    value: 'carrierId'
                },
                {
                    text: 'Carrier',
                    value: 'carrierName'
                },
                {
                    text: 'Country',
                    value: 'countryId.countryName',
                    sortable: false
                },
                {
                    text: 'Active',
                    value: 'carrierEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'carrierEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Country',
                    type: 'text',
                    value: 'countryName'
                },
                {
                    text: 'Country Short',
                    type: 'text',
                    value: 'countryShort'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'carrierEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/carriers-policies',
        name: 'CarrierPolicies',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'carrier-policy.list',
            permissionPrefix: 'carrier-policy',
            mainTitle: 'Carrier Policies',
            auth: 'admin',
            connectionName: 'CarrierPolicies',
            selectRows: false,
            formRoute: 'CarrierPoliciesForm',
            idField: 'carrierPolicyId',
            columns: [
                {
                    text: 'ID',
                    value: 'carrierPolicyId'
                },
                {
                    text: 'Type',
                    value: 'carrierPolicyType'
                },
                {
                    text: 'Name',
                    value: 'carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Description',
                    value: 'carrierPolicyDescription'
                },
                {
                    text: 'Value',
                    value: 'carrierPolicyValue'
                },
                {
                    text: 'Active',
                    value: 'carrierPolicyEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        fieldEnabled: 'carrierPolicyEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Type',
                    type: 'select',
                    value: 'carrierPolicyType',
                    values: [
                        {
                            text: 'sms_delivery_time_range',
                            value: 'sms_delivery_time_range'
                        },
                        {
                            text: 'sms_daily_quota',
                            value: 'sms_daily_quota'
                        },
                        {
                            text: 'max_charging_daily_retries',
                            value: 'max_charging_daily_retries'
                        },
                        {
                            text: 'auto_unsub_uncharged_users',
                            value: 'auto_unsub_uncharged_users'
                        }
                    ]
                },
                {
                    text: 'Description',
                    type: 'text',
                    value: 'carrierPolicyDescription'
                },
                {
                    text: 'Carrier Name',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'carrierPolicyEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/providers',
        name: 'Providers',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'provider.list',
            permissionPrefix: 'provider',
            mainTitle: 'Providers',
            auth: 'admin',
            connectionName: 'Providers',
            selectRows: false,
            formRoute: 'ProvidersForm',
            idField: 'providerId',
            columns: [
                {
                    text: 'ID',
                    value: 'providerId'
                },
                {
                    text: 'Name',
                    value: 'providerName'
                },
                {
                    text: 'Notification Endpoint',
                    value: 'providerNotificationEndpoint'
                },
                {
                    text: 'Carrier',
                    value: 'carrierId.carrierName',
                    providers: false
                },
                {
                    text: 'Active',
                    value: 'providerEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        fieldEnabled: 'providerEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'providerEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/shortcodes',
        name: 'Shortcodes',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'shortcode.list',
            permissionPrefix: 'shortcode',
            mainTitle: 'Shortcodes',
            auth: 'admin',
            connectionName: 'Shortcodes',
            selectRows: false,
            formRoute: 'ShortcodesForm',
            idField: 'shortcodeId',
            columns: [
                {
                    text: 'ID',
                    value: 'shortcodeId'
                },
                {
                    text: 'Shortcode',
                    value: 'shortcode'
                },
                {
                    text: 'Relation',
                    value: 'shortcodeRelation'
                },
                {
                    text: 'Type',
                    value: 'shortcodeType'
                },
                {
                    text: 'Carrier',
                    value: 'providerId.carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName',
                    sortable: false
                },
                {
                    text: 'Active',
                    value: 'shortcodeEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'shortcodeEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Shortcode',
                    type: 'text',
                    value: 'shortcode'
                },
                {
                    text: 'Relation',
                    type: 'text',
                    value: 'shortcodeRelation'
                },
                { text: 'Carrier', type: 'text', value: 'carrierName' },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Type',
                    type: 'select',
                    value: 'shortcodeType',
                    values: [
                        {
                            text: 'free',
                            value: 'free'
                        },
                        {
                            text: 'charge',
                            value: 'charge'
                        }
                    ]
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'shortcodeEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/billing-codes',
        name: 'BillingCodes',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'billing-code.list',
            permissionPrefix: 'billing-code',
            mainTitle: 'Billing Codes',
            auth: 'admin',
            connectionName: 'BillingCodes',
            selectRows: false,
            formRoute: 'BillingCodesForm',
            idField: 'billingCodeId',
            columns: [
                {
                    text: 'ID',
                    value: 'billingCodeId'
                },
                {
                    text: 'Code',
                    value: 'billingCode'
                },
                {
                    text: 'Description',
                    value: 'billingCodeDescription'
                },
                {
                    text: 'Price',
                    value: 'billingCodePrice'
                },
                {
                    text: 'Type',
                    value: 'billingType'
                },
                {
                    text: 'Carrier',
                    value: 'shortcodeId.providerId.carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Shortcode',
                    value: 'shortcodeId.shortcode',
                    sortable: false
                },
                {
                    text: 'Active',
                    value: 'billingCodeEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'billingCodeEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Code',
                    type: 'text',
                    value: 'billingCode'
                },
                {
                    text: 'Price',
                    type: 'text',
                    value: 'billingCodePrice'
                },
                {
                    text: 'Type',
                    type: 'select',
                    value: 'billingType',
                    values: [
                        {
                            text: 'mt',
                            value: 'mt'
                        },
                        {
                            text: 'api',
                            value: 'api'
                        }
                    ]
                },
                { text: 'Carrier', type: 'text', value: 'carrierName' },
                {
                    text: 'Shortcode',
                    type: 'text',
                    value: 'shortcode'
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'billingCodeEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/products',
        name: 'Products',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'product.list',
            permissionPrefix: 'product',
            mainTitle: 'Products',
            auth: 'admin',
            connectionName: 'Products',
            selectRows: false,
            formRoute: 'ProductsForm',
            idField: 'productId',
            columns: [
                {
                    text: 'ID',
                    value: 'productId'
                },
                {
                    text: 'Name',
                    value: 'productName'
                },
                {
                    text: 'Periodicity',
                    value: 'productPeriodicity'
                },
                {
                    text: 'Carrier',
                    value: 'providerId.carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Quiet Time Enabled',
                    value: 'productQuietTimeEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName',
                    sortable: false
                },
                {
                    text: 'Shortcode',
                    value: 'shortcodeId.shortcode',
                    sortable: false
                },
                {
                    text: 'Daily Subscriptions (Max)',
                    value: 'productMaxDailySubs'
                },
                {
                    text: 'Monthly Subscriptions (Max)',
                    value: 'productMaxMonthlySubs'
                },
                {
                    text: 'Free Trial Period (days)',
                    value: 'productFreeTrial'
                },
                {
                    text: 'Retation Days',
                    value: 'productRetationDays'
                },
                {
                    text: 'Active',
                    value: 'productEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'productEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Name',
                    type: 'text',
                    value: 'productName'
                },
                {
                    text: 'Periodicity',
                    type: 'text',
                    value: 'productPeriodicity'
                },
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Quiet Time Enabled',
                    type: 'text',
                    value: 'productQuietTimeEnabled'
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Shortcode',
                    type: 'text',
                    value: 'shortcode'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'productEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/product-keywords',
        name: 'ProductKeywords',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'product-keyword.list',
            permissionPrefix: 'product-keyword',
            mainTitle: 'Product Keywords',
            auth: 'admin',
            connectionName: 'ProductKeywords',
            selectRows: false,
            formRoute: 'ProductKeywordsForm',
            idField: 'productKeywordId',
            columns: [
                {
                    text: 'ID',
                    value: 'productKeywordId'
                },
                {
                    text: 'Keyword',
                    value: 'productKeyword'
                },
                {
                    text: 'Type',
                    value: 'productKeywordType'
                },
                {
                    text: 'Carrier',
                    value: 'productId.providerId.carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Provider',
                    value: 'productId.providerId.providerName',
                    sortable: false
                },
                {
                    text: 'Product',
                    value: 'productId.productName',
                    sortable: false
                },
                {
                    text: 'Active',
                    value: 'productKeywordEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'productKeywordEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Keyword',
                    type: 'text',
                    value: 'productKeyword'
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Keyword Type',
                    type: 'select',
                    values: [
                        {
                            text: 'subscription',
                            value: 'subscription'
                        },
                        {
                            text: 'unsubscription',
                            value: 'unsubscription'
                        },
                        {
                            text: 'optin',
                            value: 'optin'
                        },
                        {
                            text: 'optout',
                            value: 'optout'
                        },
                        {
                            text: 'help',
                            value: 'help'
                        }
                    ],
                    value: 'productKeywordType'
                },
                {
                    text: 'Product',
                    type: 'text',
                    value: 'productName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'productKeywordEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/messages',
        name: 'Messages',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'message.list',
            permissionPrefix: 'message',
            mainTitle: 'Messages',
            auth: 'admin',
            connectionName: 'Messages',
            selectRows: false,
            formRoute: 'MessagesForm',
            idField: 'messageId',
            columns: [
                {
                    text: 'ID',
                    value: 'messageId'
                },
                {
                    text: 'Message',
                    value: 'message'
                },
                {
                    text: 'Type',
                    value: 'messageType'
                },
                {
                    text: 'Carrier',
                    value: 'productId.providerId.carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Provider',
                    value: 'productId.providerId.providerName',
                    sortable: false
                },
                {
                    text: 'Product',
                    value: 'productId.productName',
                    sortable: false
                },
                {
                    text: 'Active',
                    value: 'messageEnabled',
                    customField: {
                        type: 'boolean'
                    }
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'messageEnabled',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Message',
                    type: 'text',
                    value: 'message'
                },
                {
                    text: 'Product',
                    type: 'text',
                    value: 'productName'
                },
                {
                    text: 'Provider',
                    type: 'text',
                    value: 'providerName'
                },
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                },
                {
                    text: 'Active',
                    type: 'select',
                    value: 'messageEnabled',
                    values: [
                        {
                            text: 'yes',
                            value: true
                        },
                        {
                            text: 'no',
                            value: 'false'
                        }
                    ]
                }
            ]
        }
    },
    {
        path: 'settings/blacklist',
        name: 'Blacklist',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'blacklist.list',
            permissionPrefix: 'blacklist',
            mainTitle: 'Blacklist',
            auth: 'admin',
            connectionName: 'Blacklists',
            getDataFromFile: true,
            infoFileFormat: 'CSV format should be: msisdn, expire_date, carrier_id',
            selectRows: false,
            formRoute: 'BlacklistsForm',
            idField: 'blacklistId',
            columns: [
                {
                    text: 'ID',
                    value: 'blacklistId'
                },
                {
                    text: 'MSISDN',
                    value: 'blacklistMsisdn'
                },
                {
                    text: 'Expire Date',
                    value: 'blacklistExpireDate',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Carrier',
                    value: 'carrierId.carrierName',
                    sortable: false
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        type: 'options',
                        fieldEnabled: 'blacklistId',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'MSISDN',
                    type: 'text',
                    value: 'blacklistMsisdn'
                },
                {
                    text: 'Carrier',
                    type: 'text',
                    value: 'carrierName'
                }
            ]
        }
    },
    {
        path: 'report-settings/categories',
        name: 'Categories',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'report-category.list',
            permissionPrefix: 'report-category',
            mainTitle: 'Report Categories',
            auth: 'admin',
            connectionName: 'ReportCategories',
            getDataFromFile: false,
            selectRows: false,
            formRoute: 'ReportcategoriesForm',
            idField: 'categoryId',
            columns: [
                {
                    text: 'ID',
                    value: 'categoryId'
                },
                {
                    text: 'Category Name',
                    value: 'categoryName'
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        fieldEnabled: 'categoryEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Category Name',
                    type: 'text',
                    value: 'categoryName'
                }
            ]
        }
    },
    {
        path: 'report-settings/datasources',
        name: 'Datasources',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'report-datasource.list',
            permissionPrefix: 'report-datasource',
            mainTitle: 'Report Datasources',
            auth: 'admin',
            connectionName: 'ReportDatasources',
            getDataFromFile: false,
            selectRows: false,
            formRoute: 'ReportdatasourcesForm',
            idField: 'datasourceId',
            columns: [
                {
                    text: 'ID',
                    value: 'datasourceId'
                },
                {
                    text: 'Datasource Name',
                    value: 'datasourceName'
                },
                {
                    text: 'Datasource Host',
                    value: 'datasourceHost'
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        fieldEnabled: 'datasourceEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Datasource Name',
                    type: 'text',
                    value: 'datasourceName'
                }
            ]
        }
    },
    {
        path: 'report-settings/chart-types',
        name: 'ChartTypes',
        type: 'ADM',
        parentName: 'Admin',
        meta: {
            routePermissions: 'report-chart-types.list',
            permissionPrefix: 'report-chart-types',
            mainTitle: 'Report Chart Types',
            auth: 'admin',
            connectionName: 'ReportChartTypes',
            getDataFromFile: false,
            selectRows: false,
            formRoute: 'ReportcharttypesForm',
            idField: 'chartTypeId',
            columns: [
                {
                    text: 'ID',
                    value: 'chartTypeId'
                },
                {
                    text: 'Chart Type Name',
                    value: 'chartTypeName'
                },
                {
                    text: 'Last Modified',
                    value: 'dateModified',
                    customField: {
                        type: 'date'
                    }
                },
                {
                    text: 'Actions',
                    width: '100px',
                    customField: {
                        fieldEnabled: 'chartTypeEnabled',
                        type: 'options',
                        hideAll: false
                    }
                }
            ],
            filters: [
                {
                    text: 'Chart Type Name',
                    type: 'text',
                    value: 'chartTypeName'
                }
            ]
        }
    }
]

export default json
